<template>
  <a-layout-content>
    <a-form-model layout="inline">
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="代理帐号">
            <a-input v-model="qry.puid" type="text" />
          </a-form-model-item>
          <a-form-model-item label="会员帐号">
            <a-input v-model="qry.uid" type="text" />
          </a-form-model-item>
          <a-form-model-item label="派送状态">
            <a-select v-model="qry.ispay" default-value="-1" style="width: 120px">
              <a-select-option value="-1">--全部--</a-select-option>
              <a-select-option value="0">未派送</a-select-option>
              <a-select-option value="1">已派送</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" html-type="submit" @click="query()"><a-icon type="search"
                style="font-size: 20px" /></a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <div class="body-nest">
      <a-table bordered row-key="Puid" size="small" :columns="columns" :data-source="userrows"
        :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :loading="loading">
        <template slot="title">
          <a-row :gutter="24">
            <a-col :span="6" style="line-height: 30px">佣金列表</a-col>
            <a-button type="primary" @click="uploadBtn">批量汇入<a-icon type="upload" /></a-button>
            <a-button type="primary" @click="ExportSelectData">导出<a-icon type="download" /></a-button>
            <a-button type="primary" @click="batchpayout">批量派送</a-button>
            <a-button type="primary" @click="showtotalbet('btn')">显示总投注</a-button>
          </a-row>
        </template>
        <template slot="Ispay" slot-scope="text, record">
          <a-tag color="cyan" v-if="record.Ispay == '1'">已派送</a-tag>
          <a-tag color="red" v-else-if="record.Ispay == '0'">未派送</a-tag>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-tooltip title="编辑">
            <a @click="editModal(record)">
              <a-icon type="edit" style="font-size: 22px"></a-icon>
            </a>
          </a-tooltip>
        </template>
      </a-table>
      <div style="margin: 16px 0; height: 8px">
        <a-pagination style="float: right" show-size-changer :default-current="pagination.current"
          :total="pagination.total" :show-total="(total) => `共 ${total} 条`" :pageSizeOptions="pagination.sizeList"
          @change="pageNumberChange" @showSizeChange="sizeChange" />
      </div>
    </div>

    <!-------------------------------------------------------弹窗部份--------------------------------------------------------->
    <a-modal v-model="visible" title="编辑" width="40%" ok-text="储存" cancel-text="取消" @ok="onEditSubmit">
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="派送状态">
          <a-select v-model="edit.Ispay" style="width: 100px" default-value="0">
            <a-select-option value="0">未派送</a-select-option>
            <a-select-option value="1">已派送</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="edit.Memo" :auto-size="{ minRows: 3, maxRows: 10 }" class="areaSize"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->
    <!-------------------------------------------------------上传弹窗--------------------------------------------------------->
    <a-modal v-model="uploadVisible" title="上传代理" @ok="handleUpload">
      <div style="height: 200px">
        <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button style="width:200px;"> <a-icon type="upload" /> 选择文件 </a-button>
        </a-upload> <br>
        <a-button type="primary" @click="dowTemplate">
          下载模板
        </a-button>
      </div>
    </a-modal>
    <!-------------------------------------------------------弹窗结束--------------------------------------------------------->


  </a-layout-content>
</template>

<script>
  let userrows = [];
  let totalvaildbetcol = false;
  import XLSX from "xlsx";
  import moment from "moment";
  import { jsonExportSheet, arrayExport } from "../../js/xlsxTool";

  export default {
    data() {
      return {
        loading: false,
        visible: false,
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        fileList: [],
        uploadVisible: false,
        qry: {
          puid: "",
          uid: "",
          ispay: "-1",
          page: "1",
          pagesize: "10",
        },
        edit: {
          Puid: "",
          Memo: "",
          Ispay: "1",
        },
        //--table --
        columns: IninTable(),
        userrows,
        selectedRowKeys: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          sizeList: ["10", "50", "500", "5000", "10000"],
        },
      };
    },
    methods: {
      query() {
        this.showtotalbet('query');
        let params = {
          Uid: this.qry.uid,
          Puid: this.qry.puid,
          Ispay: this.qry.ispay,
          pageindex: this.pagination.current,
          pagesize: this.pagination.pageSize,
        };

        this.axios.post("/agentpromotion/getagentpromotiondetailslist", params).then((res) => {
          this.userrows = res.data;
          this.pagination.total = res.total;
        });
      },
      //批量选取
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      //编辑
      editModal(record) {
        this.visible = true;
        this.edit.Puid = record.Puid;
        this.edit.Ispay = record.Ispay.toString();
        this.edit.Memo = record.Memo;
      },
      onEditSubmit() {
        let params = {
          Puid: this.edit.Puid,
          Ispay: this.edit.Ispay,
          Memo: this.edit.Memo,
        };

        this.axios.post("/agentpromotion/agentpromotiondetailsedit", params).then((res) => {
          if (res.data) {
            this.$message.success("保存成功!");
            this.query();
          } else {
            this.$message.error(res.error);
          }
        });
      },
      batchpayout() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量派送",
          content: "您要确定要派送勾选数据吗?",
          onOk() {
            const StringList = [];
            that.selectedRowKeys.forEach((element) => {
              StringList.push({ ID: element });
            });
            that.axios
              .post("/agentpromotion/agentpromotiondetailsbatchpayout", {
                StringList: StringList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("派送成功");
                  that.query();
                }
              });
          },
        });
      },
      uploadBtn() {
        this.uploadVisible = true;
        this.fileList = [];
      },
      // 下载模板
      dowTemplate() {
        var aoa = [
          ["代理账号", "总入款", "电子类有效投注", "真人体育类有效投注", "昨日新增会员", "备注"],
          ["AGGTCS01(最长50)", 10, 10, 10, "", ""]
        ];
        arrayExport(aoa, "佣金上传模板");
      },
      isExcel(file) {
        return /\.(xlsx|xls|csv)$/.test(file.name);
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        if (!this.isExcel(file)) {
          this.$message.error("仅支持上传.xlsx、.xls、.csv、后缀文件");
          return false;
        }
        this.fileList = [file];
        return false;
      },
      handleUpload() {
        if (this.fileList.length < 1) {
          this.$message.success("请选择文件");
          return;
        }
        const that = this;
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary", cellDates: true });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const header = that.getHeaderRow(worksheet);
            // 改变头部
            //账号 真实姓名 还款金额 还款方式 IP 备注 提交时间 审核时间
            worksheet["A1"].w = "Puid";
            worksheet["B1"].w = "DepositAmt";
            worksheet["C1"].w = "SlotVaildbetAmt";
            worksheet["D1"].w = "VaildbetAmt";
            worksheet["E1"].w = "Members";
            worksheet["F1"].w = "Memo";
            //var results = XLSX.utils.sheet_to_json(worksheet);
            var results = XLSX.utils.sheet_to_json(worksheet, {raw : false});
            this.generateData({ header, results });
            resolve();
          };
          reader.readAsArrayBuffer(that.fileList[0]);
        });
      },
      generateData({ header, results }) {
        this.axios.post("/agentpromotion/importagentpromotiondetails",
          { ImportAgentDetails: results }
        ).then((res) => {
          if (res.data) {
            this.fileList = [];
            this.mymessage(this, "导入成功");
            this.query();
          }
        });
      },
      getHeaderRow(sheet) {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        let C;
        const R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
          const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
          let hdr = "UNKNOWN " + C;
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
          headers.push(hdr);
        }
        return headers;
      },

      //批量导出
      ExportSelectData() {
        let params = {
          Uid: this.qry.uid,
          Puid: this.qry.puid,
          Ispay: this.qry.ispay,
          pageindex: 0,
          pagesize: 0,
        };

        let today = new Date();
        this.$message.success(
          "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
        );
        this.axios({
          url: "/agentpromotion/exportagentpromotiondetails",
          method: "post",
          data: params,
          responseType: "blob",
        }).then((response) => {
          let blob = new Blob([response.data], { type: response.data.type });
          // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download =
              "佣金- " + today.toISOString().split("T")[0]; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉 blob 对象
          }
        });
      },
      //分页显示条数的变化
      sizeChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.query();
      },
      //分页页数的改变
      pageNumberChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.query();
      },
      showtotalbet(flag) {
        if (flag == "btn") {
          totalvaildbetcol = totalvaildbetcol ? false : true;
        }
        else if (flag == "query") {
          totalvaildbetcol = false;
        }
        this.columns = IninTable();
      }
    },
    created() {
      this.query();
    },
  };

  const IninTable = function IninTable() {
    var header = [];
    header.push({ title: "日期", align: "center", dataIndex: "Date" });
    header.push({ title: "代理账号", align: "center", dataIndex: "Puid" });
    header.push({ title: "会员账号", align: "center", dataIndex: "Uid" });
    header.push({ title: "佣金总额", align: "center", dataIndex: "Bonus" });
    header.push({ title: "昨日总入款", align: "center", dataIndex: "Depositamt" });
    header.push({ title: "电子类有效投注", align: "center", dataIndex: "SlotVaildBetAmt" });
    header.push({ title: "真人体育类有效投注", width: 150, align: "center", dataIndex: "VaildBetAmt" });
    if (totalvaildbetcol) {
      header.push({ title: "总有效投注", align: "center", dataIndex: "TotalVaildBetAmt" });
    }
    header.push({ title: "昨日会员数量", align: "center", dataIndex: "Members" });
    header.push({
      title: "是否派送",
      align: "center",
      dataIndex: "Ispay",
      scopedSlots: { customRender: "Ispay" },
    });
    header.push({
      title: "派送時間",
      align: "center",
      dataIndex: "Paytime",
      customRender: (text, record) => {
        text = record.Paytime.substring(0, 4) == "1900" ? "" : record.Paytime;
        return text;
      },
      sorter: (a, b) =>
        new Date(a.Paytime.replace(/[\u4e00-\u9fa5]/g, "")).getTime() -
        new Date(b.Paytime.replace(/[\u4e00-\u9fa5]/g, "")).getTime(),
    });
    header.push({ title: "备注", align: "center", dataIndex: "Memo" });
    header.push({
      title: "操作",
      align: "center",
      dataIndex: "operation",
      ellipsis: true,
      scopedSlots: { customRender: "operation" },
      width: 100,
    });
    return header;
  };
</script>


<style>
  .areaSize {
    width: 300px;
  }
</style>


// WEBPACK FOOTER //
// src/components/agentpromotion/agentpromotiondetail.vue